import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { NIcon, NSwitch } from 'naive-ui';
import { Moon, Sun } from '@vicons/carbon';

import { key, Mutation, Theme } from '@/store/types';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const themeHash = {
  [Theme.LIGHT]: false,
  [Theme.DARK]: true,
};

const store = useStore(key);
const active = computed({
  get: () => themeHash[store.state.theme],
  set: () => store.commit(Mutation.SWITCH_THEME),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSwitch), {
    value: _unref(active),
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(active) ? (active).value = $event : null))
  }, {
    "checked-icon": _withCtx(() => [
      _createVNode(_unref(NIcon), { component: _unref(Moon) }, null, 8, ["component"])
    ]),
    "unchecked-icon": _withCtx(() => [
      _createVNode(_unref(NIcon), { component: _unref(Sun) }, null, 8, ["component"])
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})